module.exports = __webpack_public_path__ + "static/media/get-on-apple.546fa480.svg";